var env = require("../utils/env");
var apiDomain = env.domain.api;
var Auth = require("./auth");
var request = require('superagent');
var async = require('async');

var exports = module.exports = {};

exports.retrieveStudentCurrentCourses = function(options,callback) {

    var currentUser = Auth.currentUser;

    callback = callback || function() {};
    options = options || {};
    options.conditions = options.conditions || {};

    request
        .get(apiDomain + '/v1/courses')
        .query({
            sort: options.sort,
            // limit: options.limit,
            // skip: options.skip,
            // tree: options.tree,
            // max_level: options.max_level,
            // root: options.root,
            conditions0: JSON.stringify(options.conditions0),
            // startTime: options.startTime,
            // endTime: options.endTime,
            // concept_config: JSON.stringify(options.concept_config),
            include: options.include,
            // conditions1: JSON.stringify(options.includeConditions)
        })
        .then(function(response) {
            return callback(null, response.body);
        }, function(err) {
            var ERR;
            if (err.response) ERR = err.response.body;
            else ERR = err;
            return callback(ERR);
        })
}

exports.retrieveStudentAllTimeStats = function(options,callback) {

    var currentUser = Auth.currentUser;

    callback = callback || function() {};
    options = options || {};
    options.conditions = options.conditions || {};

    request
        .get(apiDomain + '/v1/alltimestats')
        .query({
            sort: options.sort,
            // limit: options.limit,
            // skip: options.skip,
            // tree: options.tree,
            // max_level: options.max_level,
            // root: options.root,
            conditions: JSON.stringify(options.conditions),
            // startTime: options.startTime,
            // endTime: options.endTime,
            concept_config: JSON.stringify(options.concept_config),
            // include: options.include,
            // conditions1: JSON.stringify(options.includeConditions)
        })
        .then(function(response) {
            return callback(null, response.body);
        }, function(err) {
            var ERR;
            if (err.response) ERR = err.response.body;
            else ERR = err;
            return callback(ERR);
        })
}

exports.retrieveStudentAggregate = function(options,callback) {

    var currentUser = Auth.currentUser;

    callback = callback || function() {};
    options = options || {};
    options.conditions = options.conditions || {};

    request
        .get(apiDomain + '/v1/alltimestats/aggregate')
        .query({
            aggregate_aliases: "avgMasteryScore",
            aggregate_cmds:"avg",
            aggregate_fields:"masteryScore",
            // limit: options.limit,
            // skip: options.skip,
            // tree: options.tree,
            // max_level: options.max_level,
            // root: options.root,
            conditions: JSON.stringify(options.conditions),
            group_fields:"concept",
            // sort: options.sort,
            
            // startTime: options.startTime,
            // endTime: options.endTime,
            // concept_config: JSON.stringify(options.concept_config),
            // include: options.include,
            // conditions1: JSON.stringify(options.includeConditions)
        })
        .then(function(response) {
            return callback(null, response.body);
        }, function(err) {
            var ERR;
            if (err.response) ERR = err.response.body;
            else ERR = err;
            return callback(ERR);
        })
}



exports.retrieveStudentConceptMap = function(options,callback) {

    var currentUser = Auth.currentUser;

    callback = callback || function() {};
    options = options || {};
    options.conditions = options.conditions || {};

    request
        .get(apiDomain + '/v1/concepts')
        .query({
            sort: options.sort,
            // limit: options.limit,
            // skip: options.skip,
            tree: options.tree,
            max_level: options.max_level,
            root: options.root,
            conditions: JSON.stringify(options.conditions),
            // startTime: options.startTime,
            // endTime: options.endTime,
            // concept_config: JSON.stringify(options.concept_config),
            // include: options.include,
            // conditions1: JSON.stringify(options.includeConditions)
        })
        .then(function(response) {
            return callback(null, response.body);
        }, function(err) {
            var ERR;
            if (err.response) ERR = err.response.body;
            else ERR = err;
            return callback(ERR);
        })
}

exports.retrieveStudentActivitesForMonth = function(options, callback) {

    var currentUser = Auth.currentUser;

    callback = callback || function() {};
    options = options || {};
    options.conditions = options.conditions || {};

    request
        .get(apiDomain + '/v1/attempts')
        .query({
            sort: options.sort,
            // limit: options.limit,
            skip: options.skip,
            conditions: JSON.stringify(options.conditions),
            // startTime: options.startTime,
            // endTime: options.endTime,
            // concept_config: JSON.stringify(options.concept_config),
            // include: options.include,
            // conditions1: JSON.stringify(options.includeConditions)
        })
        .then(function(response) {
            return callback(null, response.body);
        }, function(err) {
            var ERR;
            if (err.response) ERR = err.response.body;
            else ERR = err;
            return callback(ERR);
        })
}

exports.retrieveStudentAttempt = function(options,callback) {

    var currentUser = Auth.currentUser;

    callback = callback || function() {};
    options = options || {};
    options.conditions = options.conditions || {};

    request
        .get(apiDomain + '/v1/attempts/' + options.attemptID)
        .query({
            // aggregate_aliases: "avgMasteryScore",
            // aggregate_cmds:"avg",
            // aggregate_fields:"masteryScore",

            // conditions: JSON.stringify(options.conditions),
            // group_fields:"concept",

            
            // sort: options.sort,
            
            // startTime: options.startTime,
            // endTime: options.endTime,
            // concept_config: JSON.stringify(options.concept_config),
            // include: options.include,
            // conditions1: JSON.stringify(options.includeConditions)
        })
        .then(function(response) {
            return callback(null, response.body);
        }, function(err) {
            var ERR;
            if (err.response) ERR = err.response.body;
            else ERR = err;
            return callback(ERR);
        })
}

exports.retrieveStudentMistakesBankForMonth = function(options, callback) {

    var currentUser = Auth.currentUser;

    callback = callback || function() {};
    options = options || {};
    options.conditions = options.conditions || {};

    request
        .get(apiDomain + '/v1/timestats')
        .query({
            sort: options.sort,
            // limit: options.limit,
            skip: options.skip,
            conditions: JSON.stringify(options.conditions),
            startTime: options.startTime,
            endTime: options.endTime,
            concept_config: JSON.stringify(options.concept_config),
            // include: options.include,
            conditions1: JSON.stringify(options.includeConditions)
        })
        .then(function(response) {
            return callback(null, response.body);
        }, function(err) {
            var ERR;
            if (err.response) ERR = err.response.body;
            else ERR = err;
            return callback(ERR);
        })
}

exports.retrieveConceptForMistake = function(options, callback) {

    var currentUser = Auth.currentUser;

    callback = callback || function() {};
    options = options || {};
    options.conditions = options.conditions || {};

    request
        .get(apiDomain + '/v1/student/mistakesbank/concept/' + options.conceptID)
        .query({
            sort: options.sort,
            // limit: options.limit,
            skip: options.skip,
            conditions: JSON.stringify(options.conditions),
            // include: options.include,
        })
        .then(function(response) {
            return callback(null, response.body);
        }, function(err) {
            var ERR;
            if (err.response) ERR = err.response.body;
            else ERR = err;
            return callback(ERR);
        })
    
}

exports.retrieveMistakesForSpecific = function(options, callback) {

    var currentUser = Auth.currentUser;

    callback = callback || function() {};
    options = options || {};
    options.conditions = options.conditions || {};

    request
        .get(apiDomain + '/v1/attempts_mistake')
        .query({
            sort: options.sort,
            // limit: options.limit,
            skip: options.skip,
            conditions: JSON.stringify(options.conditions),
            conditions0: JSON.stringify(options.conditions0),
            conditions1: options.conditions1,
            include: options.include,
        })
        .then(function(response) {
            return callback(null, response.body);
        }, function(err) {
            var ERR;
            if (err.response) ERR = err.response.body;
            else ERR = err;
            return callback(ERR);
        })
}


/** WEBPACK FOOTER **
 ** ./src/resources/analytics.js
 **/